<template>
  <div id="checkSet">
    <div class="content">
      <el-cascader
        v-model="measureNos"
        :options="paramOptions"
        :props="{value:'code',label:'name',children:'childHashSet',emitPath:false,multiple:true}"
        :show-all-levels="false"
        collapse-tags
      ></el-cascader>
      <el-button type="primary" class="submit" @click="submitButton">保存设置</el-button>
    </div>
  </div>
</template>

<script>
    export default {
        name: "checkSet",
        data() {
            return {
                measureNos: [],//选中的值
                paramOptions: [], //下拉
                dates: [],//选中的时间
            }
        },
        mounted() {
            let date = new Date();
            this.dates.push(
                date.getFullYear() +
                "-" +
                (date.getMonth() + 1) +
                "-" +
                (date.getDate() - 1)+
                " "+"00:00:00"

            );
            this.dates.push(
                date.getFullYear() +
                "-" +
                (date.getMonth() + 1) +
                "-" +
                date.getDate()+
                " "+"00:00:00"
            );
            this.projectMenus()
            this.getData()
        },
        methods: {
            getData() {
                this.$axios.get('/api/monitor/dataHistory/getQuerySet').then(res => {
                    if (res.data.status == 200) {
                        if (res.data.datas.values.measureNos) {
                            this.measureNos = res.data.datas.values.measureNos.split(',')
                            // if(res.data.datas.values.startTime===''|| res.data.datas.values.endTime===''){
                            //
                            // }else{
                            //     this.dates.push(res.data.datas.values.startTime, res.data.datas.values.endTime)
                            // }
                        }
                    }
                })
            },
            projectMenus() {
                this.$axios.get('/api/monitor/dataHistory/getMeasureByCode').then(res => {
                    this.paramOptions = res.data.datas.values;
                })
            },
            submitButton() {
                if (this.measureNos.length == 0) {
                    this.$message({message: '请先选择测点', type: 'warning'})
                    return
                }
                if (this.dates.length == 0) {
                    this.$message({message: '请选择时间段', type: 'warning'})
                    return
                }
                let form = {
                    measureNos: this.measureNos.toString(),
                    startTime: this.dates[0],
                    endTime: this.dates[1]
                }
                this.$axios.post('/api/monitor/dataHistory/addQuerySet', form).then(res => {
                    if (res.data.status === 200) {
                        this.getData()
                        this.$message({message: '设置成功', type: "success"})
                    } else {
                        this.$message({message: '设置成功', type: "error"})
                    }
                })
            }
        }
    }
</script>
<style>
  #checkSet .el-cascader .el-input .el-input__inner {
    color: #FFF;
    background-color: #3457DE;
  }

  #checkSet .el-date-editor--daterange.el-input__inner {
    background-color: #3457DE;
    color: #FFF;
  }

  #checkSet .el-date-editor .el-range-input {
    background-color: #3457DE;
    color: #FFF;
  }

  #checkSet .el-date-editor .el-range-separator {
    background-color: unset;
    color: #FFF;
  }
</style>

<style scoped>

  .content {
    margin:0 15px;
    background-image: linear-gradient(to right, rgba(13,39,82,0.8), rgba(6,21,43,1));
    padding: 20px 10px;
    border: 1px solid rgb(19,100,182);
    color: #04012c;
  }

  .submit {
    margin-left: 30px;
    background-color: #E68F02;
    border: #E68F02;
    color: #FFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/dataManage/checkSet.vue